import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  getHideNavbar,
  getIncludeClAttribution,
  getFastForwarding,
} from '../selectors';
import FastForwarding from './FastForwarding';
import Block from './Block';
import Navbar from './Navbar';
import TestModeBadge from './TestModeBadge';
import SandboxModeBadge from './SandboxModeBadge';
import DeveloperModeBadge from './DeveloperModeBadge';
import ProgressBar from './ProgressBar';
import clLogo from '../../assets/images/cl-logo-short.png';

class AppSession extends React.Component {
  static propTypes = {
    hideNavbar: PropTypes.bool.isRequired,
    includeClAttribution: PropTypes.bool.isRequired,
    fastForwarding: PropTypes.bool,
  }

  static defaultProps = {
    fastForwarding: false,
  }

  renderNavbar = () => {
    if (!this.props.hideNavbar) {
      return (
        <Navbar />
      );
    }
    return '';
  }

  renderClAttributionElement = () => {
    if (this.props.includeClAttribution) {
      return (
        <div className="cl-attribution">
          <a href="https://www.info.community.lawyer/" target="_blank" rel="noopener noreferrer">
            <img
              className="cl-attribution__logo"
              src={clLogo}
              alt="Community.lawyer"
            />
            <div>
              <p>
                Made with
                <span>Community.lawyer</span>
              </p>
            </div>
          </a>
        </div>
      );
    }
    return '';
  }

  render() {
    const { fastForwarding } = this.props;
    if (fastForwarding) {
      return (
        <FastForwarding />
      );
    }
    return (
      <React.Fragment>
        <span className="v4" />
        {this.renderNavbar()}
        <div className="app-body">
          <ProgressBar />
          <Block />
        </div>
        <div className="test-mode-wrapper">
          <TestModeBadge />
          <SandboxModeBadge />
          <DeveloperModeBadge />
        </div>
        {this.renderClAttributionElement()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const hideNavbar = getHideNavbar(state);
  const includeClAttribution = getIncludeClAttribution(state);
  const fastForwarding = getFastForwarding(state);

  return {
    hideNavbar,
    includeClAttribution,
    fastForwarding,
  };
};

export default connect(mapStateToProps)(AppSession);
